<template>
    <div :class="$style.container"
         id="loading"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-container>
            <div  id="jurisdiction1">
                <div :class="$style.left">
                    <el-row>
                        <el-col>
                            <div style="padding-top: 8px;margin-bottom:30px;font-weight: bold;">辖区变更列表</div>
                        </el-col>
                    </el-row>


                </div>
                <el-row style="width: 200px;margin: 0 auto;">
                    <el-button-group >
                        <el-button @click.native="init('audit')"
                                   :class="class_active ? 'btn_active' : 'btn_inactive'"
                                   style="width: 100px">待审核</el-button>
                        <el-button
                                :class="class_active ? 'btn_inactive' : 'btn_active'"
                                @click.native="init('already')"
                                style="width: 100px">已审批</el-button>
                    </el-button-group>
                </el-row>
                <div style="width: 100%;margin-top:10px;">
                    <el-form label-width="120px" >
                        <el-row>
                            <el-row>
                                <el-col :span="12" style="position: relative;margin-top: 30px">
                            <span  style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">销售渠道
                            </span>
                                    <el-checkbox-group v-model="channelCheckList" style="display: inline-block">
                                        <el-checkbox label="INSTITUTION" style="color: #606266;" v-if="clientObj.showInstitution">医疗机构</el-checkbox>
                                        <el-checkbox label="RETAILSTORE" style="color: #606266;" v-if="clientObj.showStore">零售终端</el-checkbox>
                                        <el-checkbox label="DISTRIBUTOR" style="color: #606266;" v-if="clientObj.showDistributor">分销客户</el-checkbox>
                                    </el-checkbox-group>

                                </el-col>
                                <el-col :span="12" style="position: relative;margin-top: 20px;text-align: right">
                                    <span  style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">客户名称</span>
                                    <el-input type="text" v-model="customer_name" placeholder="请输入客户名称"
                                              style="width: calc(100% - 90px)" >
                                    </el-input>
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 20px;">

                                <el-col :span="12">
                                    <span  style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">客户类型</span>
                                    <el-select v-model="customer_type" placeholder="" disabled style="width: calc(100% - 120px)">
                                        <el-option
                                                v-for="item in customerOptions"
                                                :key="item.key"
                                                :label="item.value"
                                                :value="item.key">
                                        </el-option>
                                    </el-select>

                                </el-col>
                                <el-col :span="12" style="margin-top:10px;">
                                    <span  style="padding-left: 10px;font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">调整类型</span>
                                    <el-checkbox-group v-model="adjustCheckList" style="display: inline-block">
                                        <el-checkbox label="ADD" style="color: #7ED321 ">移入辖区</el-checkbox>
                                        <el-checkbox label="NEW" style="color: #FF9901 ">添加新客户</el-checkbox>
                                        <el-checkbox label="REMOVE" style="color: #ED3B3F ">移出辖区</el-checkbox>
                                        <el-checkbox label="LOCATION" style="color: #d68af9 ">签到位置</el-checkbox>
                                    </el-checkbox-group>

                                </el-col>

                            </el-row>
                            <el-row style="margin-top: 30px">
                                <el-col :span="12">
                                    <span  style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">提交日期
                                            </span>
                                    <div style="display: inline-block;width: calc(100% - 120px)">
                                                <el-date-picker
                                                v-model="submitStart_time"
                                                type="date"
                                                style="width:47%"
                                                placeholder="选择日期"
                                                @change="chooseTimeRange0"
                                                >
                                    </el-date-picker><span style="display: inline-block;width: 6%;text-align: center">至
                                                </span><el-date-picker
                                                v-model="submitEnd_time"
                                                type="date"
                                                placeholder="选择日期"
                                                style="width:47%"
                                                @change="chooseTimeRange2"
                                                >
                                    </el-date-picker>
                                    </div>
                                </el-col>
                                <el-col :span="12" v-if="!class_active">
                                    <span  style="padding-left: 10px; font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">审批日期
                                            </span>
                                    <div style="display: inline-block;width: calc(100% - 96px)">
                                        <el-date-picker
                                                v-model="approvalStart_time"
                                                type="date"
                                                style="width:47%"
                                                placeholder="选择日期"
                                                @change="chooseTimeRange3"
                                        >
                                        </el-date-picker><span style="display: inline-block;width: 6%;text-align: center">至
                                                </span><el-date-picker
                                            v-model="approvalEnd_time"
                                            type="date"
                                            placeholder="选择日期"
                                            style="width:47%"
                                            @change="chooseTimeRange4"
                                    >
                                    </el-date-picker>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row style="margin-top:41px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                                <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
                                <el-button type="danger" size="small" @click.stop="handleResetClick">重置</el-button>
                            </el-row>
                            <el-row>
                                <el-col style="width: 120px;height: 70px;border: 2px solid #F167F0;float: right;margin-top:20px;margin-left: 20px;" v-if="clientObj.showInstitution">
                                    <p style="font-size:16px;color: #F167F0;margin:10px;">分销客户</p>
                                    <p style="font-size:24px;color: #F167F0;margin:10px;text-align: center">{{businessNum}}</p>
                                </el-col>
                                <el-col style="width: 120px;height: 70px;border: 2px solid #FF9901;float: right;margin-top:20px;margin-left: 20px;" v-if="clientObj.showStore">
                                    <p style="font-size:16px;color: #FF9901;margin:10px;">零售终端</p>
                                    <p style="font-size:24px;color: #FF9901;margin:10px;text-align: center">{{retailNum}}</p>
                                </el-col>
                                <el-col style="width: 120px;height: 70px;border: 2px solid #6BC235;float: right;margin-top:20px;margin-left: 20px;" v-if="clientObj.showDistributor">
                                    <p style="font-size:16px;color: #6BC235;margin:10px;">医疗机构</p>
                                    <p style="font-size:24px;color: #6BC235;margin:10px;text-align: center">{{medicalNum}}</p>
                                </el-col>
                                <el-col v-if="class_active" style="width: 120px;height: 70px;border: 2px solid #4A90E2;float: right;margin-top:20px;margin-left: 20px;">
                                    <p  style="font-size:16px;color: #4A90E2;margin:10px;">待审批总数</p>
                                    <p style="font-size:24px;color: #4A90E2;margin:10px;text-align: center">{{pendingNum}}</p>
                                </el-col>
                                <el-col v-else style="width: 120px;height: 70px;border: 2px solid #4A90E2;float: right;margin-top:20px;margin-left: 20px;">
                                    <p style="font-size:16px;color: #4A90E2;margin:10px;">本月审批总数</p>
                                    <p style="font-size:24px;color: #4A90E2;margin:10px;text-align: center">{{approvalNum}}</p>
                                </el-col>
                            </el-row>
                            <div style="margin-bottom: 20px">
                                <el-table
                                        v-if="class_active"
                                        :data="territoryEnrollmentList"
                                        :header-cell-style="{'color':'black','font-size':'15px'}"
                                        border
                                        style="width: 100%;margin-top: 20px"
                                        stripe>
                                    <el-table-column
                                            fixed
                                            type="index"
                                            label="序号"
                                            width="60px">
                                    </el-table-column>
                                    <el-table-column
                                            prop="reference_obj"
                                            sortable
                                            label="销售渠道"
                                            width="105"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                            min-width="300"
                                            prop="customer_name"
                                            sortable
                                            label="客户">
                                    </el-table-column>
                                    <el-table-column
                                            prop="customer_type"
                                            sortable
                                            label="客户类型"
                                            width="105">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.reference_obj ==='医疗机构'" >机构</span>
                                            <span v-else-if="scope.row.reference_obj =='零售终端'" >门店</span>
                                            <span v-else-if="scope.row.reference_obj =='分销客户'" >经销商</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="enrollment_type"
                                            sortable
                                            label="调整类型"
                                            width="105">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.enrollment_type ==='移入辖区'" style="color: #7ED321">{{scope.row.enrollment_type}}</span>
                                            <span v-else-if="scope.row.enrollment_type =='移出辖区'" style="color: #ED3B3F">{{scope.row.enrollment_type}}</span>
                                            <span v-else-if="scope.row.enrollment_type =='添加新客户'" style="color: #FF9901">{{scope.row.enrollment_type}}</span>
                                            <span v-else-if="scope.row.enrollment_type =='签到位置'" style="color: #d68af9">{{scope.row.enrollment_type}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            min-width="300"
                                            prop="comments"
                                            sortable
                                            label="申请理由">
                                    </el-table-column>
                                    <el-table-column
                                            prop="created_date"
                                            label="提交日期"
                                            sortable
                                            width="150"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                            fixed="right" label="操作"
                                            width="80"
                                            style="color: #3b99f7"
                                            label-class-name="jurisdiction1_table_cell"
                                    >
                                        <template slot-scope="scope">
                                            <el-button
                                                    style="color: #fff;background: #FE904C;border:none;border-radius: 10%" size="small"
                                                    @click="handleDetail(scope.row)">详情
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <pagination v-if="class_active" :page="page" @changePage="changePageClick"></pagination>
                                <el-table
                                        v-if='!class_active'
                                        :data="territorySubmitList"
                                        border
                                        style="width: 100%;margin-top: 20px"
                                        :header-cell-style="{'color':'black','font-size':'15px'}"
                                        stripe>
                                    <el-table-column
                                            fixed
                                            type="index"
                                            label="序号"
                                            width="60px">
                                    </el-table-column>
                                    <el-table-column
                                            prop="reference_obj"
                                            sortable
                                            label="销售渠道"
                                            width="150px">
                                    </el-table-column>
                                    <el-table-column
                                            min-width="300"
                                            prop="customer_name"
                                            sortable
                                            label="客户">
                                    </el-table-column>
                                    <el-table-column
                                            prop="customer_type"
                                            sortable
                                            label="客户类型"
                                            width="105"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.reference_obj ==='医疗机构'" >机构</span>
                                            <span v-else-if="scope.row.reference_obj =='零售终端'" >门店</span>
                                            <span v-else-if="scope.row.reference_obj =='分销客户'" >经销商</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            width="105"
                                            prop="enrollment_type"
                                            sortable
                                            label="调整类型">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.enrollment_type ==='移入辖区'" style="color: #7ED321">{{scope.row.enrollment_type}}</span>
                                            <span v-else-if="scope.row.enrollment_type =='移出辖区'" style="color: #ED3B3F">{{scope.row.enrollment_type}}</span>
                                            <span v-else-if="scope.row.enrollment_type =='添加新客户'" style="color: #FF9901">{{scope.row.enrollment_type}}</span>
                                            <span v-else-if="scope.row.enrollment_type =='签到位置'" style="color: #d68af9">{{scope.row.enrollment_type}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="created_date"
                                            label="提交日期"
                                            sortable
                                            width="150"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                            prop="approved_date"
                                            label="审批日期"
                                            sortable
                                            width="150"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                            prop="approved_result"
                                            label="审批结果"
                                            sortable
                                            width="120"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.approved_result ==='APPROVED'" style="color: #7ED321">已通过</span>
                                            <span v-else-if="scope.row.approved_result =='DENIED'" style="color: #ED3B3F">已拒绝</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            fixed="right" label="操作"
                                            width="110"
                                            style="color: #3b99f7"
                                            label-class-name="jurisdiction1_table_cell"
                                    >
                                        <template slot-scope="scope">
                                            <el-button
                                                    style="color: #fff;background: #FE904C;border:none;border-radius: 10%" size="small"
                                                    @click="approvedHandleDetail(scope.row)">详情
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <pagination v-if='!class_active' :page="page1" @changePage="changePageClick1"></pagination>
                            </div>

                        </el-row>

                    </el-form>
                </div>
            </div>
        </el-container>

        <!--机构申请-->
        <el-dialog
                :visible.sync="dialogVisible1"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">辖区调整申请
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
<!--                            <el-button type="success" size="small" v-if="class_active" @click="submitApproval">-->
<!--                                提交审批-->
<!--                            </el-button>-->
                            <el-button type="danger" size="small" @click="dialogVisible1 = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div class="HcpClass" style="margin-top: 20px;">
                    <el-row style="border: 1px solid #DCDFE6;background: #EEF2F6;width: 100%;height: 270px;margin:20px auto;">
                        <el-form ref="form" label-width="120px" :model="form" style="margin-top:20px;">
                            <el-col :span="24">
                                    <el-form-item label="调整类型" >
                                        <p v-if="institutionType == 1 ? true:false" style="margin:0; font-size: 16px;color:#7ED321;" >将现有机构移入辖区</p>
                                        <p style="margin:0; font-size: 16px;color:#FF9901;" v-if="institutionType == 2 ? true:false">在辖区内添加新的机构</p>
                                        <p style="margin:0; font-size: 16px;color:#ED3B3F;" v-if="institutionType == 3 ? true:false">将现有机构移出辖区</p>
                                        <p style="margin:0; font-size: 16px;color:#d68af9;" v-if="institutionType == 4 ? true:false">调整机构的签到位置坐标</p>
                                    </el-form-item>

                            </el-col>
                            <el-col :span="24">
                                    <el-form-item label="机构名称">
                                        <p style="margin:0;font-size: 16px;color:#4A90E2;">{{institution_name}}</p>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                    <el-form-item label="推广产品">
                                        <span v-if="productStyle">
                                            <span v-for="(a,b) in productArray" style="margin:0;background: #FF9901;color: #fff;border-radius: 5px;padding: 0 10px;margin-right: 10px;">{{a.product_name}}</span>
                                        </span>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                    <el-form-item label="申请理由">
                                        <p style="margin:0;color: #87909A;">{{applyReason}}</p>
                                    </el-form-item>
                            </el-col>
                        </el-form>
                    </el-row>
                    <el-row class="HcpClass1">
                        <el-col>
                            <el-tabs v-model="activeName1" >
                                <el-tab-pane label="基本信息" name="first">
                                    <el-form ref="form" label-width="130px" :model="basicInfoForm" style="font-size: 14px;margin-top: 10px;">
                                        <el-col :span="12">
                                            <el-form-item label="名称">
                                                <el-input v-model="basicInfoForm.institution_name" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="编码">
                                                <el-input v-model="basicInfoForm.institution_code" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="类别">
                                                <el-select v-model="basicInfoForm.institution_type" placeholder=""  disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in TypeList"
                                                            :key="item.key"
                                                            :label="item.value1"
                                                            :value="item.key"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="级别">
                                                <el-select v-model="basicInfoForm.institution_grade" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in GardeList1"
                                                            :key="item.key"
                                                            :label="item.value1"
                                                            :value="item.key"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="省份">
                                                <el-select v-model="basicInfoForm.province_id" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in data1"
                                                            :key="item.province_id"
                                                            :label="item.province_name"
                                                            :value="item.province_id"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="城市">
                                                <el-select v-model="basicInfoForm.city_id" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in CityList1"
                                                            :key="item.city_id"
                                                            :label="item.city_name"
                                                            :value="item.city_id"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="地址">
                                                <el-input v-model="basicInfoForm.address" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="联系电话">
                                                <el-input v-model="basicInfoForm.telephone" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="邮政编码">
                                                <el-input v-model="basicInfoForm.postcode" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="官方网址">
                                                <el-input v-model="basicInfoForm.website" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="所属经销商">
                                                <el-select v-model="basicInfoForm.distributor_id" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in distributorList"
                                                            :key="item.distributor_id"
                                                            :label="item.distributor_name"
                                                            :value="item.distributor_id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="开发进度">
                                                <el-select v-model="basicInfoForm.agreement_stage" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in INSTITUTION_AGREEMENT_STAGE"
                                                            :key="item.key"
                                                            :label="item.value1"
                                                            :value="item.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="已进药">
                                                <el-switch
                                                        v-model="basicInfoForm.agreement_signed"
                                                        active-color="#13ce66"
                                                        active-value="ACTIVE"
                                                        inactive-value="INACTIVE"
                                                        disabled>
                                                </el-switch>
                                            </el-form-item>
                                        </el-col>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane :label="items.group_name" :name="items.name" v-for="(items,j) in extendedInfo">
                                    <div class="subjectList" style="margin-top: 20px;">
                                        <el-form   :ref="'list'+j" label-width="30%" v-for="(item,j) in items.fieldArray" :model="item" :key="item.field_id">
                                            <el-col :span="24" v-if="item.input_type == 'TEXT'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input v-model="item.field_value" placeholder="" disabled ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24" v-else-if="item.input_type == 'NUMBER'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input v-model="item.field_value" placeholder="" type="number" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24" v-else-if="item.input_type == 'DATE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-date-picker
                                                            v-model="item.field_value"
                                                            type="date"
                                                            placeholder=""
                                                            style="width: 100%"
                                                            format="yyyy-MM-dd"
                                                            value-format="yyyy-MM-dd"
                                                            disabled>
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-switch
                                                            v-model="item.field_value"
                                                            active-color="#13ce66"
                                                            active-value="T"
                                                            inactive-value = "F"
                                                            disabled
                                                    >
                                                    </el-switch>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24" v-else-if="item.input_type == 'LIST'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-cascader
                                                            v-model="item.field_value"
                                                            :options="item.listArray"
                                                            style="width: 100%"
                                                            filterable
                                                            disabled
                                                            placeholder=""
                                                            :show-all-levels="false"
                                                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                                                            clearable></el-cascader>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :span="24" v-else-if="item.input_type == 'TABLE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-table
                                                            :data="item.field_value"
                                                            border
                                                            style="width: 100%">
                                                        <el-table-column
                                                                type="index"
                                                                label="序号"
                                                                width="50">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="date_name"
                                                                label="标准科室"
                                                                v-if="item.array_dept !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="product_name"
                                                                label="产品"
                                                                v-if="item.array_product !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="sku_name"
                                                                label="SKU"
                                                                v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="date_name"
                                                                label="日期"
                                                                v-if="item.array_date !== 'NONE' "
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="field_value"
                                                                label="数值"
                                                        >
                                                        </el-table-column>

                                                    </el-table>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :span="24" v-else>
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input  :rows="3" v-model="item.field_value" placeholder="" type="textarea" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-form>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="签到位置" name="third">
                                    <div class="amap-page-container" style="height: 300px">
                                        <el-amap
                                                vid="mapDemo1"
                                                :center="center"
                                                :zoom="12"
                                                :plugin="plugin"
                                                :amapManager="amapManager"
                                                class="amap-demo"
                                                style="position: relative;"
                                        >
                                            <el-amap-marker

                                                    :position="center.position"
                                                    :template="center.template"
                                                    :events="center.events"
                                                    v-for="center in centers">
                                            </el-amap-marker>
                                        </el-amap>
                                    </div>
                                    <div style="margin-top: 10px" class="amap">
                                        <el-form ref="formapLocation" :model="locationForm" label-width="80px">
                                            <el-form-item label="名称">

                                                <el-input v-model="locationForm.location_name" disabled></el-input>

                                            </el-form-item>
                                            <el-form-item label="地址">

                                                <el-input v-model="locationForm.address" disabled></el-input>

                                            </el-form-item>
                                        </el-form>
                                    </div>

                                </el-tab-pane>
                            </el-tabs>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>
        <!--门店申请-->
        <el-dialog
                :visible.sync="dialogVisible2"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">辖区调整申请
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
<!--                            <el-button type="success" size="small" v-if="class_active" @click="submitApproval">-->
<!--                                提交审批-->
<!--                            </el-button>-->
                            <el-button type="danger" size="small" @click="dialogVisible2 = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div class="HcpClass" style="margin-top: 20px;">
                    <el-row style="border: 1px solid #DCDFE6;background: #EEF2F6;width: 100%;height: 270px;margin:20px auto;">
                        <el-form ref="form" label-width="120px" :model="form" style="margin-top:20px;">
                            <el-col :span="24">
                                    <el-form-item label="调整类型" >
                                        <p v-if="institutionType == 1 ? true:false" style="margin:0; font-size: 16px;color:#7ED321;" >将现有门店移入辖区</p>
                                        <p style="margin:0; font-size: 16px;color:#FF9901;" v-if="institutionType == 2 ? true:false">在辖区内添加新的门店</p>
                                        <p style="margin:0; font-size: 16px;color:#ED3B3F;" v-if="institutionType == 3 ? true:false">将现有门店移出辖区</p>
                                        <p style="margin:0; font-size: 16px;color:#d68af9;" v-if="institutionType == 4 ? true:false">调整门店的签到位置坐标</p>
                                    </el-form-item>

                            </el-col>
                            <el-col :span="24">
                                    <el-form-item label="门店名称">
                                        <p style="margin:0;font-size: 16px;color:#4A90E2;">{{store_name}}</p>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                    <el-form-item label="推广产品">
                                        <span v-if="productStyle">
                                            <span v-for="(a,b) in productArray" style="margin:0;background: #FF9901;color: #fff;border-radius: 5px;padding: 0 10px;margin-right: 10px;">{{a.product_name}}</span>
                                        </span>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                    <el-form-item label="申请理由">
                                        <p style="margin:0;color: #87909A;">{{applyReason}}</p>
                                    </el-form-item>
                            </el-col>
                        </el-form>
                    </el-row>
                    <el-row class="HcpClass1">
                        <el-col>
                            <el-tabs v-model="activeName2" >
                                <el-tab-pane label="基本信息" name="first">
                                    <el-form ref="form" label-width="130px" :model="basicInfoForm" style="font-size: 14px;margin-top: 10px;">
                                        <el-col :span="12">
                                            <el-form-item label="名称">
                                                <el-input v-model="basicInfoForm.store_name" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="编码">
                                                <el-input v-model="basicInfoForm.store_code" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="类别">
                                                <el-select v-model="basicInfoForm.store_type" placeholder=""  disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in storeTypeList"
                                                            :key="item.key"
                                                            :label="item.value1"
                                                            :value="item.key"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="级别">
                                                <el-select v-model="basicInfoForm.retailstore_grade" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in storeGardeList"
                                                            :key="item.key"
                                                            :label="item.value1"
                                                            :value="item.key"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="省份">
                                                <el-select v-model="basicInfoForm.province_id" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in data1"
                                                            :key="item.province_id"
                                                            :label="item.province_name"
                                                            :value="item.province_id"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="城市">
                                                <el-select v-model="basicInfoForm.city_id" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in CityList1"
                                                            :key="item.city_id"
                                                            :label="item.city_name"
                                                            :value="item.city_id"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="所属医疗机构">
                                                <el-select v-model="basicInfoForm.institution_id" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in institutionList"
                                                            :key="item.institution_id"
                                                            :label="item.institution_name"
                                                            :value="item.institution_id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="地址">
                                                <el-input v-model="basicInfoForm.address" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="联系电话">
                                                <el-input v-model="basicInfoForm.telephone" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="邮政编码">
                                                <el-input v-model="basicInfoForm.postcode" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="官方网址">
                                                <el-input v-model="basicInfoForm.website" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="所属经销商">
                                                <el-select v-model="basicInfoForm.distributor_id" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in distributorList"
                                                            :key="item.distributor_id"
                                                            :label="item.distributor_name"
                                                            :value="item.distributor_id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                        <el-form-item label="开发进度">
                                            <el-select v-model="basicInfoForm.agreement_stage" placeholder="" disabled style="width: 100%">
                                                <el-option
                                                        v-for="item in RETAILSTORE_AGREEMENT_STAGE"
                                                        :key="item.key"
                                                        :label="item.value1"
                                                        :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="已进药">
                                                <el-switch
                                                        v-model="basicInfoForm.agreement_signed"
                                                        active-color="#13ce66"
                                                        active-value="ACTIVE"
                                                        inactive-value="INACTIVE"
                                                        disabled>
                                                </el-switch>
                                            </el-form-item>
                                        </el-col>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane :label="items.group_name" :name="items.name" v-for="(items,j) in extendedInfo2">
                                    <div class="subjectList" style="margin-top: 20px;">
                                        <el-form   :ref="'list'+j" label-width="30%" v-for="(item,j) in items.fieldArray" :model="item" :key="item.field_id">
                                            <el-col :span="24" v-if="item.input_type == 'TEXT'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input v-model="item.field_value" placeholder="" disabled ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24" v-else-if="item.input_type == 'NUMBER'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input v-model="item.field_value" placeholder="" type="number" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24" v-else-if="item.input_type == 'DATE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-date-picker
                                                            v-model="item.field_value"
                                                            type="date"
                                                            placeholder=""
                                                            style="width: 100%"
                                                            format="yyyy-MM-dd"
                                                            value-format="yyyy-MM-dd"
                                                            disabled>
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-switch
                                                            v-model="item.field_value"
                                                            active-color="#13ce66"
                                                            active-value="T"
                                                            inactive-value = "F"
                                                            disabled
                                                    >
                                                    </el-switch>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24" v-else-if="item.input_type == 'LIST'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-cascader
                                                            v-model="item.field_value"
                                                            :options="item.listArray"
                                                            style="width: 100%"
                                                            filterable
                                                            disabled
                                                            placeholder=""
                                                            :show-all-levels="false"
                                                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                                                            clearable></el-cascader>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :span="24" v-else-if="item.input_type == 'TABLE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-table
                                                            :data="item.field_value"
                                                            border
                                                            style="width: 100%">
                                                        <el-table-column
                                                                type="index"
                                                                label="序号"
                                                                width="50">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="date_name"
                                                                label="标准科室"
                                                                v-if="item.array_dept !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="product_name"
                                                                label="产品"
                                                                v-if="item.array_product !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="sku_name"
                                                                label="SKU"
                                                                v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="date_name"
                                                                label="日期"
                                                                v-if="item.array_date !== 'NONE' "
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="field_value"
                                                                label="数值"
                                                        >
                                                        </el-table-column>

                                                    </el-table>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :span="24" v-else>
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input  :rows="3" v-model="item.field_value" placeholder="" type="textarea" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-form>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="签到位置" name="third">
                                    <div class="amap-page-container" style="height: 300px">
                                        <el-amap
                                                vid="mapDemo2"
                                                :center="center"
                                                :zoom="12"
                                                :plugin="plugin"
                                                :amapManager="amapManager"
                                                class="amap-demo"
                                                style="position: relative;"
                                        >
                                            <el-amap-marker

                                                    :position="center.position"
                                                    :template="center.template"
                                                    :events="center.events"
                                                    v-for="center in centers">
                                            </el-amap-marker>
                                        </el-amap>
                                    </div>
                                    <div style="margin-top: 10px" class="amap">
                                        <el-form ref="formapLocation" :model="locationForm" label-width="80px">
                                            <el-form-item label="名称">

                                                <el-input v-model="locationForm.location_name" disabled></el-input>

                                            </el-form-item>
                                            <el-form-item label="地址">

                                                <el-input v-model="locationForm.address" disabled></el-input>

                                            </el-form-item>
                                        </el-form>
                                    </div>

                                </el-tab-pane>
                            </el-tabs>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>

        <!--经销商申请-->
        <el-dialog
                :visible.sync="dialogVisible3"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">辖区调整申请
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
<!--                            <el-button type="success" size="small" v-if="class_active" @click="submitApproval">-->
<!--                                提交审批-->
<!--                            </el-button>-->
                            <el-button type="danger" size="small" @click="dialogVisible3 = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div class="HcpClass" style="margin-top: 20px;">
                    <el-row style="border: 1px solid #DCDFE6;background: #EEF2F6;width: 100%;height: 270px;margin:20px auto;">
                        <el-form ref="form" label-width="120px" :model="form" style="margin-top:20px;">
                            <el-col :span="24">
                                    <el-form-item label="调整类型" >
                                        <p v-if="institutionType == 1 ? true:false" style="margin:0; font-size: 16px;color:#7ED321;" >将现有经销商移入辖区</p>
                                        <p style="margin:0; font-size: 16px;color:#FF9901;" v-if="institutionType == 2 ? true:false">在辖区内添加新的经销商</p>
                                        <p style="margin:0; font-size: 16px;color:#ED3B3F;" v-if="institutionType == 3 ? true:false">将现有经销商移出辖区</p>
                                        <p style="margin:0; font-size: 16px;color:#d68af9;" v-if="institutionType == 4 ? true:false">调整经销商的签到位置坐标</p>
                                    </el-form-item>

                            </el-col>
                            <el-col :span="24">
                                    <el-form-item label="经销商名称">
                                        <p style="margin:0;font-size: 16px;color:#4A90E2;">{{distributor_name}}</p>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                    <el-form-item label="推广产品">
                                        <span v-if="productStyle">
                                            <span v-for="(a,b) in productArray" style="margin:0;background: #FF9901;color: #fff;border-radius: 5px;padding: 0 10px;margin-right: 10px;">{{a.product_name}}</span>
                                        </span>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                    <el-form-item label="申请理由">
                                        <p style="margin:0;color: #87909A;">{{applyReason}}</p>
                                    </el-form-item>
                            </el-col>
                        </el-form>
                    </el-row>
                    <el-row class="HcpClass1">
                        <el-col>
                            <el-tabs v-model="activeName3" >
                                <el-tab-pane label="基本信息" name="first">
                                    <el-form ref="form" label-width="130px" :model="basicInfoForm" style="font-size: 14px;margin-top: 10px;">
                                        <el-col :span="12">
                                            <el-form-item label="名称">
                                                <el-input v-model="basicInfoForm.distributor_name" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="编码">
                                                <el-input v-model="basicInfoForm.distributor_code" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="类别">
                                                <el-select v-model="basicInfoForm.distributor_type" placeholder=""  disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in distributorTypeList"
                                                            :key="item.key"
                                                            :label="item.value1"
                                                            :value="item.key"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="级别">
                                                <el-select v-model="basicInfoForm.distributor_grade" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in distributorGardeList"
                                                            :key="item.key"
                                                            :label="item.value1"
                                                            :value="item.key"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="省份">
                                                <el-select v-model="basicInfoForm.province_id" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in data1"
                                                            :key="item.province_id"
                                                            :label="item.province_name"
                                                            :value="item.province_id"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="城市">
                                                <el-select v-model="basicInfoForm.city_id" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in CityList1"
                                                            :key="item.city_id"
                                                            :label="item.city_name"
                                                            :value="item.city_id"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="地址">
                                                <el-input v-model="basicInfoForm.address" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="联系电话">
                                                <el-input v-model="basicInfoForm.telephone" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="邮政编码">
                                                <el-input v-model="basicInfoForm.postcode" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="官方网址">
                                                <el-input v-model="basicInfoForm.website" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="开发进度">
                                                <el-select v-model="basicInfoForm.agreement_stage" placeholder="" disabled style="width: 100%">
                                                    <el-option
                                                            v-for="item in DISTRIBUTOR_AGREEMENT_STAGE"
                                                            :key="item.key"
                                                            :label="item.value1"
                                                            :value="item.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="已进药">
                                                <el-switch
                                                        v-model="basicInfoForm.agreement_signed"
                                                        active-color="#13ce66"
                                                        active-value="ACTIVE"
                                                        inactive-value="INACTIVE"
                                                        disabled>
                                                </el-switch>
                                            </el-form-item>
                                        </el-col>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane :label="items.group_name" :name="items.name" v-for="(items,j) in extendedInfo3">
                                    <div class="subjectList" style="margin-top: 20px;">
                                        <el-form   :ref="'list'+j" label-width="30%" v-for="(item,j) in items.fieldArray" :model="item" :key="item.field_id">
                                            <el-col :span="24" v-if="item.input_type == 'TEXT'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input v-model="item.field_value" placeholder="" disabled ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24" v-else-if="item.input_type == 'NUMBER'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input v-model="item.field_value" placeholder="" type="number" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24" v-else-if="item.input_type == 'DATE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-date-picker
                                                            v-model="item.field_value"
                                                            type="date"
                                                            placeholder=""
                                                            style="width: 100%"
                                                            format="yyyy-MM-dd"
                                                            value-format="yyyy-MM-dd"
                                                            disabled>
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-switch
                                                            v-model="item.field_value"
                                                            active-color="#13ce66"
                                                            active-value="T"
                                                            inactive-value = "F"
                                                            disabled
                                                    >
                                                    </el-switch>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24" v-else-if="item.input_type == 'LIST'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-cascader
                                                            v-model="item.field_value"
                                                            :options="item.listArray"
                                                            style="width: 100%"
                                                            filterable
                                                            disabled
                                                            placeholder=""
                                                            :show-all-levels="false"
                                                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                                                            clearable></el-cascader>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :span="24" v-else-if="item.input_type == 'TABLE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-table
                                                            :data="item.field_value"
                                                            border
                                                            style="width: 100%">
                                                        <el-table-column
                                                                type="index"
                                                                label="序号"
                                                                width="50">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="date_name"
                                                                label="标准科室"
                                                                v-if="item.array_dept !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="product_name"
                                                                label="产品"
                                                                v-if="item.array_product !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="sku_name"
                                                                label="SKU"
                                                                v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="date_name"
                                                                label="日期"
                                                                v-if="item.array_date !== 'NONE' "
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="field_value"
                                                                label="数值"
                                                        >
                                                        </el-table-column>

                                                    </el-table>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :span="24" v-else>
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input  :rows="3" v-model="item.field_value" placeholder="" type="textarea" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-form>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="签到位置" name="third">
                                    <div class="amap-page-container" style="height: 300px">
                                        <el-amap
                                                vid="mapDemo3"
                                                :center="center"
                                                :zoom="12"
                                                :plugin="plugin"
                                                :amapManager="amapManager"
                                                class="amap-demo"
                                                style="position: relative;"
                                        >
                                            <el-amap-marker

                                                    :position="center.position"
                                                    :template="center.template"
                                                    :events="center.events"
                                                    v-for="center in centers">
                                            </el-amap-marker>
                                        </el-amap>
                                    </div>
                                    <div style="margin-top: 10px" class="amap">
                                        <el-form ref="formapLocation" :model="locationForm" label-width="80px">
                                            <el-form-item label="名称">

                                                <el-input v-model="locationForm.location_name" disabled></el-input>

                                            </el-form-item>
                                            <el-form-item label="地址">

                                                <el-input v-model="locationForm.address" disabled></el-input>

                                            </el-form-item>
                                        </el-form>
                                    </div>

                                </el-tab-pane>
                            </el-tabs>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import http from '../../APIService/http'
    import pagination from '../../components/pagination'
    import jurisdiction from '../../assets/images/jurisdiction.png'
    import jurisdiction2 from '../../assets/images/jurisdiction2.png'
    import {bus} from '../../router/index.js'
    import { Message } from "element-ui";
    import moment from 'moment'
    import {AMapManager} from "vue-amap"
    import navBar from "../../components/navBar";
    import inputSelect from "../calendar/components/components/inputSelect";
    import imgUrl from "../../assets/images/mark_0.png";

    let amapManager = new AMapManager();
    export default {
        name: "jurmanageChange",
        data() {
            return {
                enrollment_id:'',
                channelCheckList:[],
                customer_name:'',
                customer_type:[],
                adjustCheckList:[],
                customerOptions:[
                    {
                        key:'INSTITUTION',
                        value:'机构'
                    },
                    {
                        key:'RETAILSTORE',
                        value:'门店'
                    },
                    {
                        key:'DISTRIBUTOR',
                        value:'经销商'
                    },
                ],
                pendingNum:0,
                approvalNum:0,
                class_active:true,
                checkList:[],
                value:'',
                options:[],
                submitStart_time:'',
                page:{
                    current: 1,
                    size: 5,
                    total: 0
                },
                page1:{
                    current: 1,
                    size: 5,
                    total: 0
                },
                submitEnd_time:'',
                approvalStart_time:'',
                approvalEnd_time:'',
                territoryEnrollmentList:[],
                territorySubmitList:[],
                medicalNum:0,
                retailNum:0,
                businessNum:0,
                dialogVisible1:false,
                dialogVisible2:false,
                dialogVisible3:false,
                activeName1:'first',
                activeName2:'first',
                activeName3:'first',
                searchStr:"",
                searchOption: {
                    city: '上海',
                    citylimit: false
                },
                plugin: [{
                    pName: 'ToolBar',
                    position:'RB',
                    locate:false,

                    events: {
                        init(instance) {

                        }
                    }

                }],
                locationForm:{
                    location_name:'',
                    address:''
                },
                institutionType:1,
                institution_name:'',
                store_name:'',
                distributor_name:'',
                productArray:[],
                productStyle:true,
                applyReason:'',
                basicInfoForm:{},
                TypeList:[],
                GardeList1:[],
                data1:[],
                CityList1:[],
                distributorList:[],
                extendedInfo:[],
                extendedInfo2:[],
                extendedInfo3:[],
                center: [116.46, 39.92],
                centers:[],
                storeTypeList:[],
                storeGardeList:[],
                institutionList:[],
                distributorTypeList:[],
                distributorGardeList:[],
                INSTITUTION_AGREEMENT_STAGE:[],
                RETAILSTORE_AGREEMENT_STAGE:[],
                DISTRIBUTOR_AGREEMENT_STAGE:[],
                clientObj:{},


            }
        },
        components: {
            pagination,
            // Upload
        },
        methods:{
            init(type){
                if (type === 'already'){
                    this.class_active = false
                    this.getTerritoryApprovedList()
                } else if (type === "audit") {
                    this.class_active = true
                    this.getTerritoryEnrollmentList()
                }
            },
            async getTerritoryEnrollmentList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        channelCheckList:this.channelCheckList,
                        customer_type:this.customer_type,
                        customer_name:this.customer_name,
                        adjustCheckList:this.adjustCheckList,
                        submitStart_time:this.submitStart_time,
                        user_id:this.$store.getters.getUser.user_id,
                        submitEnd_time:this.submitEnd_time,
                        clientObj:this.$store.getters.getClient
                    }
                    await http.post('/wapi/JurActive/getTerritoryEnrollmentList',data).then(res =>{

                        if (res.success) {
                            this.page.total = 0
                            this.territoryEnrollmentList = res.data.array
                            this.pendingNum = res.data.arrayCount.length
                            this.page.total = res.data.arrayCount1.length
                            this.medicalNum =0
                            this.retailNum =0
                            this.businessNum =0
                            res.data.arrayCount.forEach((item,i)=>{
                                if(item.reference_obj == 'INSTITUTION'){
                                    this.medicalNum += 1
                                }else if(item.reference_obj == 'RETAILSTORE'){
                                    this.retailNum += 1
                                }else{
                                    this.businessNum += 1
                                }
                            })
                            this.territoryEnrollmentList.forEach((item,i)=>{
                                item.created_date=moment(item.created_date).format('YYYY年MM月DD日')
                                if(item.reference_obj == 'INSTITUTION'){
                                    item.reference_obj = '医疗机构'
                                }else if(item.reference_obj == 'RETAILSTORE'){
                                    item.reference_obj = '零售终端'
                                }else{
                                    item.reference_obj = '分销客户'
                                }
                                if(item.enrollment_type == 'REMOVE'){
                                    item.enrollment_type = '移出辖区'
                                }else if(item.enrollment_type == 'ADD'){
                                    item.enrollment_type = '移入辖区'
                                }else if(item.enrollment_type == 'NEW'){
                                    item.enrollment_type = '添加新客户'
                                }else {
                                    item.enrollment_type = '签到位置'
                                }
                            })
                            loading.close()
                        }else {
                            Message.error(res.message);
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }

            },
            async getTerritoryApprovedList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        limit: this.page1.size,
                        offset: this.page1.current - 1,
                        channelCheckList:this.channelCheckList,
                        customer_type:this.customer_type,
                        customer_name:this.customer_name,
                        adjustCheckList:this.adjustCheckList,
                        submitStart_time:this.submitStart_time,
                        submitEnd_time:this.submitEnd_time,
                        approvalStart_time:this.approvalStart_time,
                        user_id:this.$store.getters.getUser.user_id,
                        approvalEnd_time:this.approvalEnd_time,
                        clientObj:this.$store.getters.getClient
                    }
                    await http.post('/wapi/JurActive/getTerritoryApprovedList',data).then(res =>{

                        if (res.success) {
                            console.log(res.data)
                            this.page1.total = 0
                            this.territorySubmitList = res.data.array
                            this.approvalNum = res.data.arrayCount.length
                            this.page1.total = res.data.arrayCount1.length
                            this.medicalNum =0
                            this.retailNum =0
                            this.businessNum =0
                            res.data.arrayCount.forEach((item,i)=>{
                                if(item.reference_obj == 'INSTITUTION'){
                                    this.medicalNum += 1
                                }else if(item.reference_obj == 'RETAILSTORE'){
                                    this.retailNum += 1
                                }else{
                                    this.businessNum += 1
                                }
                            })
                            this.territorySubmitList.forEach((item,i)=>{
                                item.created_date=moment(item.created_date).format('YYYY年MM月DD日')
                                item.approved_date=moment(item.approved_date).format('YYYY年MM月DD日')
                                if(item.reference_obj == 'INSTITUTION'){
                                    item.reference_obj = '医疗机构'
                                }else if(item.reference_obj == 'RETAILSTORE'){
                                    item.reference_obj = '零售终端'
                                }else{
                                    item.reference_obj = '分销客户'
                                }
                                if(item.enrollment_type == 'REMOVE'){
                                    item.enrollment_type = '移出辖区'
                                }else if(item.enrollment_type == 'ADD'){
                                    item.enrollment_type = '移入辖区'
                                }else{
                                    item.enrollment_type = '添加新客户'
                                }
                            })
                            loading.close()
                        }else {
                            Message.error(res.message);
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }

            },
            chooseTimeRange0(t){
                let time1 = moment(t).valueOf()
                let time2 = moment(this.submitEnd_time).valueOf()
                if (time1>=time2){
                    this.$message({
                        type:"warning",
                        message:"开始日期应早于开始日期"
                    })
                    this.submitStart_time = ''
                }

            },
            chooseTimeRange2(t){

                let time1 = moment(t).valueOf()
                let time2 = moment(this.submitStart_time).valueOf()


                if (time1<=time2){
                    this.$message({
                        type:"warning",
                        message:"结束日期应晚于开始日期"
                    })
                    this.submitEnd_time = ''
                }
            },
            chooseTimeRange3(t){
                let time1 = moment(t).valueOf()
                let time2 = moment(this.approvalEnd_time).valueOf()
                if (time1>=time2){
                    this.$message({
                        type:"warning",
                        message:"开始日期应早于开始日期"
                    })
                    this.approvalStart_time = ''
                }

            },
            chooseTimeRange4(t){

                let time1 = moment(t).valueOf()
                let time2 = moment(this.approvalStart_time).valueOf()


                if (time1<=time2){
                    this.$message({
                        type:"warning",
                        message:"结束日期应晚于开始日期"
                    })
                    this.approvalEnd_time = ''
                }
            },
            changePageClick(page, size){
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.getTerritoryEnrollmentList()
            },
            changePageClick1(){
                this.getTerritoryApprovedList()
            },
            handleDetail(row){
                console.log(row,943)
                this.enrollment_id = row.enrollment_id
                this.productStyle = true
                this.applyReason = row.comments
                if(row.reference_obj == '医疗机构'){
                    this.activeName1='first'
                    this.institution_name = row.customer_name
                    this.productArray=[]
                    this.getInstitutionProductArray(row.territory_id,row.reference_id,row.enrollment_id)
                    this.dialogVisible1 = true
                    if(row.enrollment_type == '移入辖区'){
                        this.institutionType = 1
                        this.getInstitutionEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo(row.reference_id)
                        this.getLocation(row.reference_id)
                    }else if(row.enrollment_type == '添加新客户'){
                        this.institutionType = 2
                        this.getInstitutionEnrollmentInfo1(row.reference_id)
                        this.getExtendedInfo1(row.reference_id)
                        this.getLocation1(row.reference_id)
                    }else if(row.enrollment_type == '签到位置'){
                        this.institutionType = 4
                        this.getInstitutionEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo(row.reference_id)
                        this.getLocation1_1(row.reference_id,row.enrollment_id,'INSTITUTION')
                    }else{
                        this.institutionType = 3
                        this.getInstitutionEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo(row.reference_id)
                        this.getLocation(row.reference_id)
                    }
                }else if(row.reference_obj == '零售终端'){
                    this.activeName2='first'
                    this.store_name = row.customer_name
                    this.productArray=[]
                    this.dialogVisible2 = true
                    this.getStoreProductArray(row.territory_id,row.reference_id,row.enrollment_id)
                    if(row.enrollment_type == '移入辖区'){
                        this.institutionType = 1
                        this.getStoreEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo2(row.reference_id)
                        this.getLocation2(row.reference_id)
                    }else if(row.enrollment_type == '添加新客户'){
                        this.institutionType = 2
                        this.getStoreEnrollmentInfo2(row.reference_id)
                        this.getExtendedInfo2_1(row.reference_id)
                        this.getLocation2_1(row.reference_id)
                    }else if(row.enrollment_type == '签到位置'){
                        this.institutionType = 4
                        this.getStoreEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo2(row.reference_id)
                        this.getLocation1_1(row.reference_id,row.enrollment_id,'RETAILSTORE')
                    }else{
                        this.institutionType = 3
                        this.getStoreEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo2(row.reference_id)
                        this.getLocation2(row.reference_id)
                    }
                }else{

                    this.activeName3='first'
                    this.distributor_name = row.customer_name
                    this.productArray=[]
                    this.dialogVisible3 = true
                    this.getDistributorProductArray(row.territory_id,row.reference_id,row.enrollment_id)
                    if(row.enrollment_type == '移入辖区'){
                        this.institutionType = 1
                        this.getDistributorEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo3(row.reference_id)
                        this.getLocation3(row.reference_id)
                    }else if(row.enrollment_type == '添加新客户'){
                        this.institutionType = 2
                        this.getDistributorEnrollmentInfo3(row.reference_id)
                        this.getExtendedInfo3_1(row.reference_id)
                        this.getLocation3_1(row.reference_id)
                    }else if(row.enrollment_type == '签到位置'){
                        this.institutionType = 4
                        this.getDistributorEnrollmentInfo(row.reference_id)
                        this.getLocation1_1(row.reference_id,row.enrollment_id,'DISTRIBUTOR')
                        this.getLocation3(row.reference_id)
                    }else{
                        this.institutionType = 3
                        this.getDistributorEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo3(row.reference_id)
                        this.getLocation3(row.reference_id)
                    }
                }

            },
            // 获取机构产品
            async getInstitutionProductArray(a,b,c){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    territory_id:a,
                    institution_id:b,
                    enrollment_id:c
                }
                await http.post('/wapi/JurActive/getInstitutionProductArray',data).then(res =>{

                    if (res.success) {
                        this.productArray = res.data
                        if(this.productArray.length == 0){
                            this.productStyle = false
                        }
                    }else {
                        Message.error(res.message);

                    }
                })
            },
            // 获取机构信息
            async getInstitutionEnrollmentInfo(a){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    institution_id:a,
                }
                await http.post('/wapi/JurActive/getInstitutionEnrollmentInfo',data).then(res =>{

                    if (res.success) {
                        this.basicInfoForm = res.data[0]
                        console.log(this.basicInfoForm)
                    }else {
                        Message.error(res.message);

                    }
                })
            },
            async getInstitutionEnrollmentInfo1(a){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    institution_id:a,
                }
                await http.post('/wapi/JurActive/getInstitutionEnrollmentInfo1',data).then(res =>{

                    if (res.success) {
                        this.basicInfoForm = res.data[0]
                        console.log(this.basicInfoForm)
                    }else {
                        Message.error(res.message);

                    }
                })
            },


            // 获取门店产品
            async getStoreProductArray(a,b,c){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    territory_id:a,
                    store_id:b,
                    enrollment_id:c
                }
                await http.post('/wapi/JurActive/getStoreProductArray',data).then(res =>{

                    if (res.success) {
                        this.productArray = res.data
                        if(this.productArray.length == 0){
                            this.productStyle = false
                        }
                    }else {
                        Message.error(res.message);

                    }
                })
            },
            // 获取门店信息
            async getStoreEnrollmentInfo(a){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    store_id:a,
                }
                await http.post('/wapi/JurActive/getStoreEnrollmentInfo',data).then(res =>{

                    if (res.success) {
                        this.basicInfoForm = res.data[0]
                    }else {
                        Message.error(res.message);

                    }
                })
            },
            async getStoreEnrollmentInfo2(a){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    store_id:a,
                }
                await http.post('/wapi/JurActive/getStoreEnrollmentInfo2',data).then(res =>{

                    if (res.success) {
                        this.basicInfoForm = res.data[0]
                    }else {
                        Message.error(res.message);

                    }
                })
            },


            // 获取经销商产品
            async getDistributorProductArray(a,b,c){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    territory_id:a,
                    distributor_id:b,
                    enrollment_id:c,
                }
                await http.post('/wapi/JurActive/getDistributorProductArray',data).then(res =>{

                    if (res.success) {
                        this.productArray = res.data
                        if(this.productArray.length == 0){
                            this.productStyle = false
                        }
                        console.log(this.productStyle,this.productArray)
                    }else {
                        Message.error(res.message);

                    }
                })
            },

            // 获取经销商信息
            async getDistributorEnrollmentInfo(a){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    distributor_id:a,
                }
                await http.post('/wapi/JurActive/getDistributorEnrollmentInfo',data).then(res =>{

                    if (res.success) {
                        this.basicInfoForm = res.data[0]
                    }else {
                        Message.error(res.message);

                    }
                })
            },
            async getDistributorEnrollmentInfo3(a){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    distributor_id:a,
                }
                await http.post('/wapi/JurActive/getDistributorEnrollmentInfo2',data).then(res =>{

                    if (res.success) {
                        this.basicInfoForm = res.data[0]
                    }else {
                        Message.error(res.message);

                    }
                })
            },



            approvedHandleDetail(row){
                console.log(row,943)
                this.enrollment_id = row.enrollment_id
                this.productStyle = true
                this.applyReason = row.comments
                if(row.reference_obj == '医疗机构'){
                    this.activeName1='first'
                    this.institution_name = row.customer_name
                    this.productArray=[]
                    this.getInstitutionProductArray(row.territory_id,row.reference_id,row.enrollment_id)
                    this.dialogVisible1 = true
                    if(row.enrollment_type == '移入辖区'){
                        this.institutionType = 1
                        this.getInstitutionEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo(row.reference_id)
                        this.getLocation(row.reference_id)
                    }else if(row.enrollment_type == '添加新客户'){
                        this.institutionType = 2
                        this.getInstitutionEnrollmentInfo1(row.reference_id)
                        this.getExtendedInfo1(row.reference_id)
                        this.getLocation1(row.reference_id)
                    }else if(row.enrollment_type == '签到位置'){
                        this.institutionType = 4
                        this.getInstitutionEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo(row.reference_id)
                        this.getLocation(row.reference_id)
                    }else{
                        this.institutionType = 3
                        this.getInstitutionEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo(row.reference_id)
                        this.getLocation(row.reference_id)
                    }
                }else if(row.reference_obj == '零售终端'){
                    this.activeName2='first'
                    this.store_name = row.customer_name
                    this.productArray=[]
                    this.dialogVisible2 = true
                    this.getStoreProductArray(row.territory_id,row.reference_id,row.enrollment_id)
                    if(row.enrollment_type == '移入辖区'){
                        this.institutionType = 1
                        this.getStoreEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo2(row.reference_id)
                        this.getLocation2(row.reference_id)
                    }else if(row.enrollment_type == '添加新客户'){
                        this.institutionType = 2
                        this.getStoreEnrollmentInfo2(row.reference_id)
                        this.getExtendedInfo2_1(row.reference_id)
                        this.getLocation2_1(row.reference_id)
                    }else if(row.enrollment_type == '签到位置'){
                        this.institutionType = 4
                        this.getStoreEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo2(row.reference_id)
                        this.getLocation2(row.reference_id)
                    }else{
                        this.institutionType = 3
                        this.getStoreEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo2(row.reference_id)
                        this.getLocation2(row.reference_id)
                    }
                }else{

                    this.activeName3='first'
                    this.distributor_name = row.customer_name
                    this.productArray=[]
                    this.dialogVisible3 = true
                    this.getDistributorProductArray(row.territory_id,row.reference_id,row.enrollment_id)
                    if(row.enrollment_type == '移入辖区'){
                        this.institutionType = 1
                        this.getDistributorEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo3(row.reference_id)
                        this.getLocation3(row.reference_id)
                    }else if(row.enrollment_type == '添加新客户'){
                        this.institutionType = 2
                        this.getDistributorEnrollmentInfo3(row.reference_id)
                        this.getExtendedInfo3_1(row.reference_id)
                        this.getLocation3_1(row.reference_id)
                    }else if(row.enrollment_type == '签到位置'){
                        this.institutionType = 4
                        this.getDistributorEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo3(row.reference_id)
                        this.getLocation3(row.reference_id)
                    }else{
                        this.institutionType = 3
                        this.getDistributorEnrollmentInfo(row.reference_id)
                        this.getExtendedInfo3(row.reference_id)
                        this.getLocation3(row.reference_id)
                    }
                }
            },
            handleQueryClick(){
                if(this.class_active){
                    this.getTerritoryEnrollmentList()
                }else{
                    this.getTerritoryApprovedList()
                }

            },
            handleResetClick(){
                    this.channelCheckList=[],
                    this.customer_name='',
                    // this.customer_type=[],
                    this.adjustCheckList=[],
                    this.submitStart_time='',
                    this.submitEnd_time=''
            },
            async getItitutionTypeList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Institution/getItitutionTypeList', data).then(res => {

                    if (res.success) {
                        self.TypeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getItitutionGardeList1() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }
                let self = this
                await http.post('/wapi/Institution/getItitutionGardeList1', data).then(res => {

                    if (res.success) {

                        self.GardeList1 = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getProvinceList() {
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                }
                let self = this
                await http.post('/wapi/Province/getProvinceList',data).then(res => {
                    if (res.success) {
                        self.data1 = res.data
                    } else {
                        Message.error(res.message);
                    }
                })

            },
            async getCityList1() {
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/City/getCityList1',data).then(res => {

                    if (res.success) {
                        self.CityList1 = res.data
                    } else {
                        Message.error(res.message);
                    }
                })

            },
            async getDistributorEnrollmentList(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                }
                await http.post('/wapi/JurActive/getDistributorEnrollmentList',data).then(res =>{

                    if (res.success) {
                        console.log(res.data)
                        this.distributorList.length = 0
                        for(var i=0;i<res.data.length;i++){
                            this.distributorList.push({
                                distributor_id:res.data[i].distributor_id,
                                distributor_name:res.data[i].distributor_name
                            })
                        }
                    }else {
                        Message.error(res.message);
                    }
                })
            },
            async getStoreTypeList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Retailstore/getRetailstoreTypeList', data).then(res => {

                    if (res.success) {
                        self.storeTypeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getRetailstoreGardeList1(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Retailstore/getRetailstoreGardeList1',data).then(res => {

                    if (res.success) {
                        self.storeGardeList=res.data
                    }else {
                        Message.error(res.message);
                    }
                })
            },
            async getInstitution(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                }
                await http.post('/wapi/JurActive/getInstitution1',data).then(res =>{

                    if (res.success) {
                        for(var i=0;i<res.data.length;i++){
                            this.institutionList.push({
                                institution_id:res.data[i].institution_id,
                                institution_name:res.data[i].institution_name
                            })
                        }
                    }else {
                        Message.error(res.message);
                    }
                })
            },
            async getDistributorTypeList(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Distributor/getDistributorTypeList',data).then(res => {

                    if (res.success) {
                        self.distributorTypeList=res.data

                    }else {
                        Message.error(res.message);
                    }
                })
            },
            async getDistributorGardeList1(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Distributor/getDistributorGardeList1',data).then(res => {

                    if (res.success) {
                        self.distributorGardeList=res.data
                    }else {
                        Message.error(res.message);
                    }
                })
            },



            // 机构扩展信息
            async getExtendedInfo(a){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    institution_id:a
                }
                await http.post('/wapi/Institution/getExtendedInfo1',data).then(res =>{

                    if (res.success) {
                        this.extendedInfo = res.data
                        if(this.extendedInfo.length>0){
                            for(let i = 0;i<this.extendedInfo.length;i++){
                                this.extendedInfo[i].fieldArray.forEach(item=>{
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value.indexOf('|') ==-1 && item.field_value !== ''){
                                        item.field_value = [item.field_value]
                                    }
                                    if(item.input_type==="LIST" && item.field_value.indexOf('|')!==-1){
                                        item.field_value = item.field_value.split('|')
                                    }
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TABLE" && item.field_value !== ''){
                                        item.field_value = JSON.parse(item.field_value)
                                    }
                                    if(item.input_type==="TABLE" && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TRUE-FALSE" && item.field_value=== ""){
                                        item.field_value = 'F'
                                    }


                                })
                            }
                        }

                    }else {
                        Message.error(res.message);

                    }
                })
            },
            async getExtendedInfo1(a){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    institution_id:a
                }
                await http.post('/wapi/JurActive/getExtendedInfo',data).then(res =>{

                    if (res.success) {
                        this.extendedInfo = res.data
                        if(this.extendedInfo.length>0){
                            for(let i = 0;i<this.extendedInfo.length;i++){
                                this.extendedInfo[i].fieldArray.forEach(item=>{
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value.indexOf('|') ==-1 && item.field_value !== ''){
                                        item.field_value = [item.field_value]
                                    }
                                    if(item.input_type==="LIST" && item.field_value.indexOf('|')!==-1){
                                        item.field_value = item.field_value.split('|')
                                    }
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TABLE" && item.field_value !== ''){
                                        item.field_value = JSON.parse(item.field_value)
                                    }
                                    if(item.input_type==="TABLE" && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TRUE-FALSE" && item.field_value=== ""){
                                        item.field_value = 'F'
                                    }


                                })
                            }
                        }

                    }else {
                        Message.error(res.message);

                    }
                })
            },
            // 机构坐标
            async getLocation(a){
                let data = {
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    reference_id:a,
                    reference_obj:'INSTITUTION',
                }
                await http.post('/wapi/Institution/getLocation',data).then(res=>{
                    if(res.success = true){
                        this.centers.length = 0;
                        if(res.data.length>0){
                            for(let i=0;i<res.data.length;i++){
                                this.locationForm.location_name = res.data[0].location_name
                                this.locationForm.address = res.data[0].address
                                this.center=[res.data[0].lng,res.data[0].lat]
                                this.centers.push({
                                    position: [res.data[i].lng, res.data[i].lat],
                                    events: {
                                        click:  ()=>{
                                            this.locationForm.location_name = res.data[i].location_name
                                            this.locationForm.address = res.data[i].address
                                        }
                                    },
                                    template: `<div style="width: 22px;color:#fff;height: 30px;text-align:center;line-height: 20px; background:url(${imgUrl})">${i+1}</div>`
                                });
                            }
                        }else{
                            this.center= [116.46, 39.92];
                            this.centers.length = 0;
                            this.locationForm.location_name = ''
                            this.locationForm.address = ''
                        }



                    }

                })

            },
            async getLocation1(a){
                let data = {
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    reference_id:a,
                    reference_obj:'INSTITUTION',
                }
                await http.post('/wapi/JurActive/getLocation',data).then(res=>{
                    if(res.success = true){
                        this.centers.length = 0;
                        if(res.data.length>0){
                            for(let i=0;i<res.data.length;i++){
                                this.locationForm.location_name = res.data[0].location_name
                                this.locationForm.address = res.data[0].address
                                this.center=[res.data[0].lng,res.data[0].lat]
                                this.centers.push({
                                    position: [res.data[i].lng, res.data[i].lat],
                                    events: {
                                        click:  ()=>{
                                            this.locationForm.location_name = res.data[i].location_name
                                            this.locationForm.address = res.data[i].address
                                        }
                                    },
                                    template: `<div style="width: 22px;color:#fff;height: 30px;text-align:center;line-height: 20px; background:url(${imgUrl})">${i+1}</div>`
                                });
                            }
                        }else{
                            this.center= [116.46, 39.92];
                            this.centers.length = 0;
                            this.locationForm.location_name = ''
                            this.locationForm.address = ''
                        }



                    }

                })

            },
            async getLocation1_1(a,b,type){
                let data = {
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    reference_id:a,
                    enrollment_id:b,
                    reference_obj:type,
                }
                await http.post('/wapi/Institution/getLocation1_1',data).then(res=>{
                    if(res.success = true){
                        this.centers.length = 0;
                        if(res.data.length>0){
                            for(let i=0;i<res.data.length;i++){
                                this.locationForm.location_name = res.data[0].location_name
                                this.locationForm.address = res.data[0].address
                                this.center=[res.data[0].lng,res.data[0].lat]
                                this.centers.push({
                                    position: [res.data[i].lng, res.data[i].lat],
                                    events: {
                                        click:  ()=>{
                                            this.locationForm.location_name = res.data[i].location_name
                                            this.locationForm.address = res.data[i].address
                                        }
                                    },
                                    template: `<div style="width: 22px;color:#fff;height: 30px;text-align:center;line-height: 20px; background:url(${imgUrl})">${i+1}</div>`
                                });
                            }
                        }else{
                            this.center= [116.46, 39.92];
                            this.centers.length = 0;
                            this.locationForm.location_name = ''
                            this.locationForm.address = ''
                        }
                    }

                })

            },

            // 门店扩展信息
            async getExtendedInfo2(a){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    retailstore_id:a
                }
                await http.post('/wapi/Retailstore/getExtendedInfo1',data).then(res =>{

                    if (res.success) {
                        this.extendedInfo2 = res.data
                        if(this.extendedInfo2.length>0){
                            for(let i = 0;i<this.extendedInfo2.length;i++){
                                this.extendedInfo2[i].fieldArray.forEach(item=>{
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value.indexOf('|') ==-1 && item.field_value !== ''){
                                        item.field_value = [item.field_value]
                                    }
                                    if(item.input_type==="LIST" && item.field_value.indexOf('|')!==-1){
                                        item.field_value = item.field_value.split('|')
                                    }
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TABLE" && item.field_value !== ''){
                                        item.field_value = JSON.parse(item.field_value)
                                    }
                                    if(item.input_type==="TABLE" && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TRUE-FALSE" && item.field_value=== ""){
                                        item.field_value = 'F'
                                    }


                                })
                            }
                        }



                    }else {
                        Message.error(res.message);

                    }
                })
            },
            async getExtendedInfo2_1(a){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    store_id:a
                }
                await http.post('/wapi/JurActive/getExtendedInfo1',data).then(res =>{

                    if (res.success) {
                        this.extendedInfo2 = res.data
                        if(this.extendedInfo2.length>0){
                            for(let i = 0;i<this.extendedInfo2.length;i++){
                                this.extendedInfo2[i].fieldArray.forEach(item=>{
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value.indexOf('|') ==-1 && item.field_value !== ''){
                                        item.field_value = [item.field_value]
                                    }
                                    if(item.input_type==="LIST" && item.field_value.indexOf('|')!==-1){
                                        item.field_value = item.field_value.split('|')
                                    }
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TABLE" && item.field_value !== ''){
                                        item.field_value = JSON.parse(item.field_value)
                                    }
                                    if(item.input_type==="TABLE" && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TRUE-FALSE" && item.field_value=== ""){
                                        item.field_value = 'F'
                                    }


                                })
                            }
                        }



                    }else {
                        Message.error(res.message);

                    }
                })
            },

            // 门店坐标
            async getLocation2(a){
                let data = {
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    reference_id:a,
                    reference_obj:'RETAILSTORE',
                }
                await http.post('/wapi/Institution/getLocation',data).then(res=>{
                    if(res.success = true){
                        this.centers.length = 0;
                        if(res.data.length>0){
                            for(let i=0;i<res.data.length;i++){
                                this.locationForm.location_name = res.data[0].location_name
                                this.locationForm.address = res.data[0].address
                                this.center=[res.data[0].lng,res.data[0].lat]
                                this.centers.push({
                                    position: [res.data[i].lng, res.data[i].lat],
                                    events: {
                                        click:  ()=>{
                                            this.locationForm.location_name = res.data[i].location_name
                                            this.locationForm.address = res.data[i].address
                                        }
                                    },
                                    template: `<div style="width: 22px;color:#fff;height: 30px;text-align:center;line-height: 20px; background:url(${imgUrl})">${i+1}</div>`
                                });
                            }
                        }else{
                            this.center= [116.46, 39.92];
                            this.centers.length = 0;
                            this.locationForm.location_name = ''
                            this.locationForm.address = ''
                        }



                    }

                })

            },
            async getLocation2_1(a){
                let data = {
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    reference_id:a,
                    reference_obj:'RETAILSTORE',
                }
                await http.post('/wapi/JurActive/getLocation',data).then(res=>{
                    if(res.success = true){
                        this.centers.length = 0;
                        if(res.data.length>0){
                            for(let i=0;i<res.data.length;i++){
                                this.locationForm.location_name = res.data[0].location_name
                                this.locationForm.address = res.data[0].address
                                this.center=[res.data[0].lng,res.data[0].lat]
                                this.centers.push({
                                    position: [res.data[i].lng, res.data[i].lat],
                                    events: {
                                        click:  ()=>{
                                            this.locationForm.location_name = res.data[i].location_name
                                            this.locationForm.address = res.data[i].address
                                        }
                                    },
                                    template: `<div style="width: 22px;color:#fff;height: 30px;text-align:center;line-height: 20px; background:url(${imgUrl})">${i+1}</div>`
                                });
                            }
                        }else{
                            this.center= [116.46, 39.92];
                            this.centers.length = 0;
                            this.locationForm.location_name = ''
                            this.locationForm.address = ''
                        }



                    }

                })

            },

            // 经销商扩展信息
            async getExtendedInfo3(a){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    distributor_id:a
                }
                await http.post('/wapi/Distributor/getExtendedInfo1',data).then(res =>{

                    if (res.success) {
                        this.extendedInfo3 = res.data
                        if(this.extendedInfo3.length>0){
                            for(let i = 0;i<this.extendedInfo3.length;i++){
                                this.extendedInfo3[i].fieldArray.forEach(item=>{
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value.indexOf('|') ==-1 && item.field_value !== ''){
                                        item.field_value = [item.field_value]
                                    }
                                    if(item.input_type==="LIST" && item.field_value.indexOf('|')!==-1){
                                        item.field_value = item.field_value.split('|')
                                    }
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TABLE" && item.field_value !== ''){
                                        item.field_value = JSON.parse(item.field_value)
                                    }
                                    if(item.input_type==="TABLE" && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TRUE-FALSE" && item.field_value=== ""){
                                        item.field_value = 'F'
                                    }


                                })
                            }
                        }


                    }else {
                        Message.error(res.message);

                    }
                })
            },
            async getExtendedInfo3_1(a){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    distributor_id:a,
                }
                await http.post('/wapi/JurActive/getExtendedInfo2',data).then(res =>{

                    if (res.success) {
                        this.extendedInfo3 = res.data
                        if(this.extendedInfo3.length>0){
                            for(let i = 0;i<this.extendedInfo3.length;i++){
                                this.extendedInfo3[i].fieldArray.forEach(item=>{
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value.indexOf('|') ==-1 && item.field_value !== ''){
                                        item.field_value = [item.field_value]
                                    }
                                    if(item.input_type==="LIST" && item.field_value.indexOf('|')!==-1){
                                        item.field_value = item.field_value.split('|')
                                    }
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TABLE" && item.field_value !== ''){
                                        item.field_value = JSON.parse(item.field_value)
                                    }
                                    if(item.input_type==="TABLE" && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TRUE-FALSE" && item.field_value=== ""){
                                        item.field_value = 'F'
                                    }


                                })
                            }
                        }



                    }else {
                        Message.error(res.message);

                    }
                })
            },

            // 经销商坐标
            async getLocation3(a){
                let data = {
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    reference_id:a,
                    reference_obj:'DISTRIBUTOR',
                }
                await http.post('/wapi/Institution/getLocation',data).then(res=>{
                    if(res.success = true){
                        this.centers.length = 0;
                        if(res.data.length>0){
                            for(let i=0;i<res.data.length;i++){
                                this.locationForm.location_name = res.data[0].location_name
                                this.locationForm.address = res.data[0].address
                                this.center=[res.data[0].lng,res.data[0].lat]
                                this.centers.push({
                                    position: [res.data[i].lng, res.data[i].lat],
                                    events: {
                                        click:  ()=>{
                                            this.locationForm.location_name = res.data[i].location_name
                                            this.locationForm.address = res.data[i].address
                                        }
                                    },
                                    template: `<div style="width: 22px;color:#fff;height: 30px;text-align:center;line-height: 20px; background:url(${imgUrl})">${i+1}</div>`
                                });
                            }
                        }else{
                            this.center= [116.46, 39.92];
                            this.centers.length = 0;
                            this.locationForm.location_name = ''
                            this.locationForm.address = ''
                        }



                    }

                })

            },
            async getLocation3_1(a){
                let data = {
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    reference_id:a,
                    reference_obj:'DISTRIBUTOR',
                }
                await http.post('/wapi/JurActive/getLocation',data).then(res=>{
                    if(res.success = true){
                        this.centers.length = 0;
                        if(res.data.length>0){
                            for(let i=0;i<res.data.length;i++){
                                this.locationForm.location_name = res.data[0].location_name
                                this.locationForm.address = res.data[0].address
                                this.center=[res.data[0].lng,res.data[0].lat]
                                this.centers.push({
                                    position: [res.data[i].lng, res.data[i].lat],
                                    events: {
                                        click:  ()=>{
                                            this.locationForm.location_name = res.data[i].location_name
                                            this.locationForm.address = res.data[i].address
                                        }
                                    },
                                    template: `<div style="width: 22px;color:#fff;height: 30px;text-align:center;line-height: 20px; background:url(${imgUrl})">${i+1}</div>`
                                });
                            }
                        }else{
                            this.center= [116.46, 39.92];
                            this.centers.length = 0;
                            this.locationForm.location_name = ''
                            this.locationForm.address = ''
                        }



                    }

                })

            },

            // 机构提交审批
            submitApproval(){
                let data={
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    enrollment_id:this.enrollment_id,
                    user_id:this.$store.getters.getUser.user_id
                }
                http.post('/wapi/JurActive/submitApproval',data).then(res=>{

                    if(res.success){
                        Message({
                            type: 'success',
                            message: '提交成功'
                        });
                        this.getTerritoryEnrollmentList()
                        this.dialogVisible1 = false
                        this.dialogVisible2 = false
                        this.dialogVisible3 = false


                    }else{
                        Message({
                            type: 'error',
                            message: '提交失败'
                        });
                    }
                })
            },
            async getDictionaryListByKOL_LEVEL1() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    category: "INSTITUTION_AGREEMENT_STAGE"
                }
                let self = this
                await http.post('/wapi/v1/getDictionaryListByCategory', data).then(res => {

                    if (res.success) {
                        self.INSTITUTION_AGREEMENT_STAGE = res.data

                    } else {
                        Message.error(res.message);
                    }

                })
            },

            async getDictionaryListByKOL_LEVEL2() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    category: "RETAILSTORE_AGREEMENT_STAGE"
                }
                let self = this
                await http.post('/wapi/v1/getDictionaryListByCategory', data).then(res => {

                    if (res.success) {
                        self.RETAILSTORE_AGREEMENT_STAGE = res.data

                    } else {
                        Message.error(res.message);
                    }

                })
            },
            async getDictionaryListByKOL_LEVEL3() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    category: "DISTRIBUTOR_AGREEMENT_STAGE"
                }
                let self = this
                await http.post('/wapi/v1/getDictionaryListByCategory', data).then(res => {

                    if (res.success) {
                        self.DISTRIBUTOR_AGREEMENT_STAGE = res.data

                    } else {
                        Message.error(res.message);
                    }

                })
            },
        },
        created() {
            this.clientObj=this.$store.getters.getClient
            this.getTerritoryEnrollmentList()
            this.getItitutionTypeList()
            this.getItitutionGardeList1()
            this.getProvinceList()
            this.getCityList1()
            this.getDistributorEnrollmentList()
            this.getStoreTypeList()
            this.getRetailstoreGardeList1()
            this.getInstitution()
            this.getDistributorTypeList()
            this.getDistributorGardeList1()
            this.getDictionaryListByKOL_LEVEL1()
            this.getDictionaryListByKOL_LEVEL2()
            this.getDictionaryListByKOL_LEVEL3()

        },
        mounted(){

        },
        updated() {
        },
        beforeDestroy() {

        },
        computed: {

        },
        watch:{

        }
    }
</script>
<style lang="scss" module>
    .container {
        background: white;
        height: 100%;
        overflow: auto;
        .left {
            font-size: 18px;
            font-weight: bold;
            color: #000000;
            float: left;
            position: absolute;
            z-index:1;
            .type {
                em {
                    color: #d98f2f;
                    font-size: 14px;
                    font-weight: bold;
                }
            }

            .first {
                color: #555555;
                font-size: 20px;
            }
            .font {
                margin-left: 20px;
                font-size: 14px;
                color: #555555;
            }
        }
        .right {
            margin-top: -20px;
            width: 100%;
            .header {
                width: 100%;
                padding-bottom: 6px;
                border-bottom: 2px dotted #e7eaec;

            }
            .body {
                overflow: auto;

            }
        }

        .noData {

        }
    }
</style>
<style scoped>
    .el-container{
        height: 100%;
        padding: 20px;
        background: white;
    }
    #jurisdiction1 {
        width: 100%;
        background: white;
        position: relative;
    }
    .HcpClass >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        font-weight: bold;
    }
    .HcpClass1 >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        font-weight: bold;
        text-align: left;
        padding-left: 20px;
    }
    .btn_active{
        color: #409EFF;
        border-color:#c6e2ff;
        background-color: #ecf5ff;
    }
    .btn_inactive{
        color: #606266;
        border-color:#DCDFE6;
        background-color: #ffffff;
    }
    #jurisdiction1 >>> .jurisdiction1_table_cell {
        color: #2b92fa !important;
    }
</style>




// WEBPACK FOOTER //
// src/pages/jurmanage/jurmanageChange.vue